var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as URLConfig from "@frameworks/web/config/domain";
import { ReportName, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { ReportName as DownloadReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { EmptyIcon, HoldingErrorEnum, } from "../action-interfaces/Reports/HoldingReport";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { FilterData, SortData, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import UnderstandingReportName, { UnderstandingReportType, } from "@domains/entities/Reports/UnderstandingSection";
import { isLoginSourceEMT, triggerDownloadReportCallback, } from "@domains/utils/emtReportCallback";
import { ERports } from "../action-interfaces/Reports/DashboardSummary";
import { ESortOrder } from "@domains/utils/sort";
import { HoldingUiState } from "@domains/aggregates/Reports/uiState";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import abortControllerClass from "@domains/utils/abortControllerClass";
import { escapeRegexStr } from "@frameworks/web/utils/regex";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
import { StreamingSectionName } from "@adapters/repositories/stream/QuoteStreamRepo";
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import throttle from "@domains/utils/throttle";
var HoldingReportPresenter = /** @class */ (function () {
    function HoldingReportPresenter(useCases, commonUsecase, understandUseCase, actions, downloadPDFReports, downloadExcelReports, sendEmailReports, dpTransactionUseCase, dpPullUseCase, dpTransactionSubmitUseCase, dpIds, useCasesStream, accountDetails, GTMService, dashBoardUsecase, dashboardActions, worker, abortController) {
        this.useCases = useCases;
        this.commonUsecase = commonUsecase;
        this.understandUseCase = understandUseCase;
        this.actions = actions;
        this.downloadPDFReports = downloadPDFReports;
        this.downloadExcelReports = downloadExcelReports;
        this.sendEmailReports = sendEmailReports;
        this.dpTransactionUseCase = dpTransactionUseCase;
        this.dpPullUseCase = dpPullUseCase;
        this.dpTransactionSubmitUseCase = dpTransactionSubmitUseCase;
        this.dpIds = dpIds;
        this.useCasesStream = useCasesStream;
        this.accountDetails = accountDetails;
        this.GTMService = GTMService;
        this.dashBoardUsecase = dashBoardUsecase;
        this.dashboardActions = dashboardActions;
        this.worker = worker;
        this.abortController = abortController;
        this.LThreeWindowbackClick = false;
        this.scrollState = 0;
        this.selectedStockISIN = undefined;
        this.selectedStockScripName = undefined;
        this.stopFamilyDetailsAPIcall = false;
        this.edisOrPledgeUrl = URLConfig.config.epledgeUrl;
        this.isNonPoaClient = false;
        this.emailAndDownload = false;
        this.initholdingReportData = {
            HoldingSummary: {
                date: "",
                message: "",
                totalInvestment: "",
                currentValue: "",
                totalPnL: "",
                daysPnL: "",
                totalPnLChange: "",
                daysPnLChange: "",
            },
            HoldingDetails: [],
            SearchData: "",
            FilterData: {
                simpleFilter: { name: "", filters: [] },
                assetFilter: { name: "", filters: [] },
                productAssetFilter: { name: "", filters: [] },
            },
            loader: true,
            SortData: [],
            IsSummarize: false,
            isOmneOnly: false,
        };
        this.holdingReportData = this.initholdingReportData;
        this.sortState = new SortData("", "", ESortOrder.UNCHANGED);
        this.filterState = new FilterData({ name: "", filters: [] }, { name: "", filters: [] }, { name: "", filters: [] });
        this.searchState = "";
        this.isSummarize = false;
        this.symbols = [];
        this.dashboardSymbols = [];
        this.initdashboardSummary = {
            holdingSummary: {
                date: undefined,
                message: undefined,
                totalInvestment: "",
                currentValue: "",
                totalPnL: "",
                daysPnL: "",
                totalPnLChange: "",
                daysPnLChange: "",
            },
            holdingDetail: [],
            holdingDashboardSummary: [],
            isOmneOnly: false,
        };
        this.dashboardSummary = this.initdashboardSummary;
    }
    HoldingReportPresenter.prototype.fetchEdisOrEpledgeUrl = function () {
        var _this = this;
        this.accountDetails.isNonPoaClient().then(function (result) {
            _this.isNonPoaClient = result;
            _this.edisOrPledgeUrl = _this.isNonPoaClient
                ? URLConfig.config.edisUrl
                : URLConfig.config.epledgeUrl;
        });
    };
    HoldingReportPresenter.prototype.getDefaultEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var email;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accountDetails.getEmailId()];
                    case 1:
                        email = _a.sent();
                        this.userDefaultEmail = email;
                        return [2 /*return*/];
                }
            });
        });
    };
    HoldingReportPresenter.prototype.downloadAndSendReport = function (email, download) {
        return __awaiter(this, void 0, void 0, function () {
            var emailPayload, loginSource, downloadPayload, downloadPayload;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (email && download) {
                            this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.Download, " | ").concat(email.reportType === ReportType.PDF
                                ? ReportsGTMConstants.PDF
                                : ReportsGTMConstants.EXCEL), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(ReportsGTMConstants.Download, " / ").concat(ReportsGTMConstants.Email, "  | ").concat(ReportsGTMConstants.Submit)));
                            this.emailAndDownload = true;
                        }
                        if (email) {
                            this.actions.hideError(HoldingErrorEnum.EMAILSTATUS);
                            emailPayload = {
                                toDate: email.toDate,
                                reportType: email.reportType,
                                emailIds: email.emailIds,
                                reportName: ReportName.HOLDINGS,
                            };
                            if (email === null || email === void 0 ? void 0 : email.accodes) {
                                emailPayload.accodes = email === null || email === void 0 ? void 0 : email.accodes;
                                emailPayload.isConsolidated = email === null || email === void 0 ? void 0 : email.isConsolidated;
                                // emailPayload.reportName = "holdings" as DownloadReportName;
                            }
                            if (!this.emailAndDownload)
                                this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.Download, " | ").concat(email.reportType === ReportType.PDF
                                    ? ReportsGTMConstants.PDF
                                    : ReportsGTMConstants.EXCEL), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(ReportsGTMConstants.Email, " | ").concat(ReportsGTMConstants.Submit)));
                            this.sendEmailReports.execute({
                                onSuccess: function (data) {
                                    _this.actions.setError({
                                        isOpen: data,
                                        error: null,
                                    }, HoldingErrorEnum.EMAILSTATUS);
                                },
                                onError: function (error) {
                                    _this.actions.setError({
                                        isOpen: false,
                                        error: error,
                                    }, HoldingErrorEnum.EMAILSTATUS);
                                },
                            }, emailPayload);
                        }
                        if (!download) return [3 /*break*/, 2];
                        this.actions.hideError(HoldingErrorEnum.DOWNLOADSTATUS);
                        return [4 /*yield*/, this.accountDetails.getLoginSrc()];
                    case 1:
                        loginSource = _a.sent();
                        if (download.reportType === ReportType.PDF ||
                            download.reportType === ReportType.PDF_DETAIL ||
                            download.reportType === ReportType.PDF_SUMMARY) {
                            downloadPayload = {
                                date: download.date,
                                reportName: DownloadReportName.HOLDINGS,
                                subReportName: DownloadReportName.HOLDINGS,
                                reportType: download.reportType,
                            };
                            if (download === null || download === void 0 ? void 0 : download.accodes) {
                                downloadPayload.accodes = download === null || download === void 0 ? void 0 : download.accodes;
                                downloadPayload.isConsolidated = download === null || download === void 0 ? void 0 : download.isConsolidated;
                            }
                            if (!this.emailAndDownload)
                                this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.Download, " | ").concat(ReportsGTMConstants.PDF), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(ReportsGTMConstants.Download, " | ").concat(ReportsGTMConstants.Submit)));
                            if (isLoginSourceEMT(loginSource)) {
                                triggerDownloadReportCallback("GET", ReportType.PDF, DownloadReportName.HOLDINGS, { date: download.date }, loginSource);
                            }
                            else {
                                this.downloadPDFReports.execute({
                                    onSuccess: function (data) {
                                        _this.actions.setError({
                                            isOpen: data,
                                            error: null,
                                        }, HoldingErrorEnum.DOWNLOADSTATUS);
                                    },
                                    onError: function (error) {
                                        _this.actions.setError({
                                            isOpen: false,
                                            error: error,
                                        }, HoldingErrorEnum.DOWNLOADSTATUS);
                                    },
                                }, downloadPayload);
                            }
                        }
                        else {
                            downloadPayload = {
                                date: download.date,
                                reportName: DownloadReportName.HOLDINGS,
                                subReportName: DownloadReportName.HOLDINGS,
                            };
                            if (download === null || download === void 0 ? void 0 : download.accodes) {
                                downloadPayload.accodes = download === null || download === void 0 ? void 0 : download.accodes;
                                downloadPayload.isConsolidated = download === null || download === void 0 ? void 0 : download.isConsolidated;
                                // downloadPayload.reportName = "holdings" as DownloadReportName;
                            }
                            this.emailAndDownload
                                ? null
                                : this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.Download, " |  ").concat(ReportsGTMConstants.EXCEL), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(ReportsGTMConstants.Download, " | ").concat(ReportsGTMConstants.Submit)));
                            if (isLoginSourceEMT(loginSource)) {
                                triggerDownloadReportCallback("GET", ReportType.EXCEL, DownloadReportName.HOLDINGS, { date: download.date }, loginSource);
                            }
                            else {
                                this.downloadExcelReports.execute({
                                    onSuccess: function (data) {
                                        _this.actions.setError({
                                            isOpen: data,
                                            error: null,
                                        }, HoldingErrorEnum.DOWNLOADSTATUS);
                                    },
                                    onError: function (error) {
                                        console.log(error, "Email error");
                                        _this.actions.setError({
                                            isOpen: false,
                                            error: error,
                                        }, HoldingErrorEnum.DOWNLOADSTATUS);
                                    },
                                }, downloadPayload);
                            }
                        }
                        _a.label = 2;
                    case 2:
                        this.emailAndDownload = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    HoldingReportPresenter.prototype.downloadSmallCaseReport = function () {
        var _this = this;
        this.actions.hideError(HoldingErrorEnum.DOWNLOADSTATUS);
        var payload = {
            subReportName: DownloadReportName.HOLDINGS + "/" + DownloadReportName.SMALLCASE,
        };
        this.downloadExcelReports.execute({
            onSuccess: function (data) {
                _this.actions.setError({
                    isOpen: data,
                    error: null,
                }, HoldingErrorEnum.DOWNLOADSTATUS);
            },
            onError: function (error) {
                _this.actions.setError({
                    isOpen: false,
                    error: error,
                }, HoldingErrorEnum.DOWNLOADSTATUS);
            },
        }, payload);
    };
    HoldingReportPresenter.prototype.getHoldingStreamData = function (subscribe, symbol) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var symb_1, streamMapKey;
            var _this = this;
            return __generator(this, function (_b) {
                try {
                    symb_1 = subscribe
                        ? ((_a = this.symbols) === null || _a === void 0 ? void 0 : _a.length) > 0
                            ? this.symbols
                            : [symbol]
                        : [];
                    streamMapKey = [
                        streamKeys[0],
                        streamKeys[1],
                        streamKeys[2],
                        streamKeys[3],
                    ];
                    this.worker.onmessage = function (event) {
                        var _a = event.data, reportData = _a.reportData, type = _a.type;
                        if (type === ReportName.HOLDINGS)
                            _this.holdingReportData = reportData;
                    };
                    this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, function (mappedData) { return __awaiter(_this, void 0, void 0, function () {
                        var combinedState, updateStreamData_1, error_1;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    if (!symb_1.includes(mappedData.symbol)) return [3 /*break*/, 2];
                                    this.worker.postMessage({
                                        type: ReportName.HOLDINGS,
                                        streamData: mappedData,
                                        reportData: this.holdingReportData,
                                    });
                                    combinedState = new HoldingUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
                                    return [4 /*yield*/, this.commonUsecase.getModifiedData(this.holdingReportData, combinedState)];
                                case 1:
                                    updateStreamData_1 = _a.sent();
                                    throttle(function () {
                                        return _this.actions.getHoldingReportData(__assign({}, updateStreamData_1));
                                    }, 1000)();
                                    _a.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    console.log(error_1);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }, symb_1, streamMapKey, StreamingSectionName.REPORTS_HOLDINGS);
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        });
    };
    HoldingReportPresenter.prototype.getDashboardData = function (req) {
        var _this = this;
        this.dashboardActions.hideError(ERports.HOLDINGS);
        this.dashboardActions.loader(ERports.HOLDINGS);
        this.dashboardSummary = this.initdashboardSummary;
        this.dashboardActions.getDashboardHoldingSummary({
            data: this.initdashboardSummary.holdingDashboardSummary,
            summary: this.initdashboardSummary.holdingSummary,
            isOmneOnly: false,
        }, ERports.HOLDINGS);
        this.dashBoardUsecase.execute({
            onSuccess: function (data) {
                _this.dashboardSummary = data;
                _this.commonUsecase
                    .dashboardSummarize(data, _this.isSummarize)
                    .then(function (x) {
                    if (x) {
                        _this.dashboardActions.getDashboardHoldingSummary({
                            data: x.holdingDashboardSummary || [],
                            summary: x.holdingSummary,
                            isOmneOnly: !!(data === null || data === void 0 ? void 0 : data.isOmneOnly),
                        }, ERports.HOLDINGS);
                    }
                    _this.dashboardActions.stopLoader(ERports.HOLDINGS);
                });
                _this.dashboardSymbols = data.holdingDetail
                    .map(function (x) { return x.quote.symbol; })
                    .filter(function (val) { return val.length > 0; });
            },
            onError: function (error) {
                _this.dashboardActions.stopLoader(ERports.HOLDINGS);
                _this.dashboardActions.setError({
                    error: error,
                    isOpen: true,
                }, ERports.HOLDINGS);
            },
        }, req);
    };
    HoldingReportPresenter.prototype.getDPTransactionHistory = function (requestData) {
        var _this = this;
        this.actions.hideError(HoldingErrorEnum.DP_TRANSACTION_ERROR_DATA);
        this.actions.hideDPEmptyValidation();
        this.actions.toggleDpTransactionLoader(true);
        this.dpTransactionUseCase.execute({
            onSuccess: function (data) {
                if (data.dpTranactions.length > 0)
                    _this.actions.setDpTransactionHistory(data);
                else {
                    var emptyDpTransaction = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.DP];
                    _this.actions.setEmptyDPValidation({ emptyDpTransaction: emptyDpTransaction });
                }
                _this.actions.toggleDpTransactionLoader(false);
            },
            onError: function (error) {
                _this.actions.toggleDpTransactionLoader(false);
                _this.actions.setError({
                    isOpen: true,
                    error: error,
                }, HoldingErrorEnum.DP_TRANSACTION_ERROR_DATA);
            },
        }, requestData);
    };
    HoldingReportPresenter.prototype.sendEmailForDPTransaction = function (email, download) {
        return __awaiter(this, void 0, void 0, function () {
            var emailPayload, loginSource, downloadPayload;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (email && download) {
                            this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.Download, " | ").concat(ReportsGTMConstants.PDF), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(ReportsGTMConstants.Email, " / ").concat(ReportsGTMConstants.Download, " | ").concat(ReportsGTMConstants.Submit)));
                            this.emailAndDownload = true;
                        }
                        if (email) {
                            this.actions.hideError(HoldingErrorEnum.EMAILSTATUS);
                            emailPayload = {
                                emailID: email === null || email === void 0 ? void 0 : email.emailIds[0],
                                filePath: email === null || email === void 0 ? void 0 : email.filePath,
                                reportName: ReportName.DP,
                            };
                            this.emailAndDownload
                                ? null
                                : this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.Download, " | ").concat(ReportsGTMConstants.PDF), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(ReportsGTMConstants.Email, " | ").concat(ReportsGTMConstants.Submit)));
                            this.sendEmailReports.execute({
                                onSuccess: function (data) {
                                    _this.actions.setError({
                                        isOpen: data,
                                        error: null,
                                    }, HoldingErrorEnum.EMAILSTATUS);
                                },
                                onError: function (error) {
                                    _this.actions.setError({
                                        isOpen: false,
                                        error: error,
                                    }, HoldingErrorEnum.EMAILSTATUS);
                                },
                            }, emailPayload);
                        }
                        if (!download) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accountDetails.getLoginSrc()];
                    case 1:
                        loginSource = _a.sent();
                        this.actions.hideError(HoldingErrorEnum.DOWNLOADSTATUS);
                        if (download.reportType === ReportType.PDF) {
                            downloadPayload = {
                                requestBody: {
                                    path: download.path,
                                },
                                reportName: DownloadReportName.DP,
                                method: "POST",
                            };
                            this.emailAndDownload
                                ? null
                                : this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.Download, " | ").concat(ReportsGTMConstants.PDF), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(ReportsGTMConstants.Download, " | ").concat(ReportsGTMConstants.Submit)));
                            if (isLoginSourceEMT(loginSource)) {
                                triggerDownloadReportCallback("POST", ReportType.PDF, DownloadReportName.DP, { path: download.path }, loginSource);
                            }
                            else {
                                this.downloadPDFReports.execute({
                                    onSuccess: function (data) {
                                        _this.actions.setError({
                                            isOpen: data,
                                            error: null,
                                        }, HoldingErrorEnum.DOWNLOADSTATUS);
                                    },
                                    onError: function (error) {
                                        _this.actions.setError({
                                            isOpen: false,
                                            error: error,
                                        }, HoldingErrorEnum.DOWNLOADSTATUS);
                                    },
                                }, downloadPayload);
                            }
                        }
                        _a.label = 2;
                    case 2:
                        this.emailAndDownload = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    HoldingReportPresenter.prototype.getDPIdList = function (accCode) {
        var _this = this;
        this.actions.toggleDpTransactionMainLoader(true);
        this.dpIds.execute({
            onSuccess: function (data) {
                _this.actions.getDpIds(data);
                _this.actions.toggleDpTransactionMainLoader(false);
            },
            onError: function (error) {
                _this.actions.toggleDpTransactionMainLoader(false);
            },
        }, accCode ? accCode : "");
    };
    HoldingReportPresenter.prototype.submitSpecificRequest = function (requestData) {
        return __awaiter(this, void 0, void 0, function () {
            var resultMessage;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.actions.hideError(HoldingErrorEnum.DP_TRANSACTION_SUBMIT_ERROR_DATA);
                        resultMessage = "";
                        //this.actions.toggleDpTransactionLoader(true);
                        return [4 /*yield*/, this.dpTransactionSubmitUseCase.execute({
                                onSuccess: function (data) {
                                    resultMessage = data;
                                },
                                onError: function (error) {
                                    // this.actions.toggleDpTransactionLoader(false);
                                    _this.actions.setError({
                                        isOpen: true,
                                        error: error,
                                    }, HoldingErrorEnum.DP_TRANSACTION_SUBMIT_ERROR_DATA);
                                },
                            }, requestData)];
                    case 1:
                        //this.actions.toggleDpTransactionLoader(true);
                        _a.sent();
                        return [2 /*return*/, resultMessage];
                }
            });
        });
    };
    HoldingReportPresenter.prototype.getHoldingReportData = function (req) {
        var _this = this;
        this.actions.hideError(HoldingErrorEnum.ERROR_DATA);
        this.actions.hideEmptyValidation();
        this.actions.setHoldingLoader(true);
        // this.actions.getHoldingReportData(this.initholdingReportData);
        if (this.abortController.abortController.signal)
            this.abortController.abortController.abort();
        if (this.abortController.abortController.signal.aborted)
            this.abortController = new abortControllerClass(new AbortController());
        this.useCases.execute({
            onSuccess: function (HoldingReportData) {
                if (HoldingReportData) {
                    _this.holdingReportData = HoldingReportData;
                    _this.filterState = HoldingReportData.FilterData;
                    _this.symbols = HoldingReportData.HoldingDetails.map(function (holding) { return holding.quote.symbol; }).filter(function (sym) { return sym !== ""; });
                    _this.actions.getHoldingReportData(_this.holdingReportData);
                }
                else {
                    _this.symbols = [];
                    _this.actions.getHoldingReportData(_this.initholdingReportData);
                    var emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.HOLDINGS];
                    _this.actions.setEmptyValidation({ emptyValidation: emptyValidation });
                }
                _this.actions.setHoldingLoader(false);
            },
            onError: function (error) {
                var errorCode = error.getErrorCode();
                _this.actions.setHoldingLoader(false);
                if (errorCode !== DOMException.ABORT_ERR.toString() &&
                    typeof error != "undefined")
                    _this.actions.setError({
                        error: error,
                        isOpen: true,
                    }, HoldingErrorEnum.ERROR_DATA);
            },
        }, (req === null || req === void 0 ? void 0 : req.familyAccodes)
            ? {
                familyAccodes: req.familyAccodes,
                abortSignal: this.abortController.abortController.signal,
            }
            : {
                abortSignal: this.abortController.abortController.signal,
            });
    };
    HoldingReportPresenter.prototype.getUnderstandingSectionData = function () {
        var _this = this;
        var payload = {
            reportName: UnderstandingReportName.HOLDINGS,
            type: UnderstandingReportType.SUMMARY_FIELD,
        };
        this.understandUseCase.execute({
            onSuccess: function (data) {
                _this.actions.getUnderstandingSectionData(data);
            },
            onError: function (error) {
                // error action
                _this.actions.setErrorUnderStandings({
                    error: error,
                    isOpen: true,
                });
            },
        }, payload);
    };
    HoldingReportPresenter.prototype.getFilteredHoldingReportData = function (filterState) {
        return __awaiter(this, void 0, void 0, function () {
            var combinedState, filterededHoldingReportData, emptyValidation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.actions.hideEmptyValidation();
                        this.filterState = filterState;
                        combinedState = new HoldingUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
                        return [4 /*yield*/, this.commonUsecase.getModifiedData(this.holdingReportData, combinedState)];
                    case 1:
                        filterededHoldingReportData = _a.sent();
                        if (filterededHoldingReportData &&
                            filterededHoldingReportData.HoldingDetails.length > 0) {
                            this.actions.getHoldingReportData(filterededHoldingReportData);
                        }
                        else {
                            emptyValidation = EmptyValidation[EmptyIcon.FILTER];
                            this.actions.getHoldingReportData(filterededHoldingReportData);
                            this.actions.setEmptyValidation({ emptyValidation: emptyValidation });
                        }
                        if (filterededHoldingReportData.FilterData.assetFilter.filters.find(function (x) { return x.selected === true; }) ||
                            filterededHoldingReportData.FilterData.simpleFilter.filters.find(function (x) { return x.selected; })) {
                            this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.FilterIcon, " ").concat(ReportsGTMConstants.Apply), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(this.filterState.simpleFilter.filters
                                .map(function (x) { return (x.selected === true ? x.title.concat(" ") : null); })
                                .join(""), " ").concat(this.filterState.assetFilter.filters
                                .map(function (x) { return (x.selected === true ? x.title.concat(" ") : null); })
                                .join(""))));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HoldingReportPresenter.prototype.getSortedHoldingReportData = function (newSortState, GATagCall) {
        var _this = this;
        // if clicked on the same key then change the order otherwise sort in assending (default)
        this.sortState = newSortState;
        GATagCall
            ? this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.OrderIcon, " | ").concat(ReportsGTMConstants.Apply), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(this.sortState.displayName)))
            : null;
        var combinedState = new HoldingUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
        this.commonUsecase
            .getModifiedData(this.holdingReportData, combinedState)
            .then(function (sortedHoldingReportData) {
            return _this.actions.getHoldingReportData(sortedHoldingReportData);
        });
    };
    HoldingReportPresenter.prototype.getSummarizeHoldingReportData = function (isSummarize) {
        var _this = this;
        this.isSummarize = isSummarize;
        var combinedState = new HoldingUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
        this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.SummarizeValues), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(this.isSummarize
            ? ReportsGTMConstants.Enable
            : ReportsGTMConstants.Disable)));
        this.commonUsecase
            .getModifiedData(this.holdingReportData, combinedState)
            .then(function (summarizedHoldingReportData) {
            return _this.actions.getHoldingReportData(summarizedHoldingReportData);
        });
        this.commonUsecase
            .dashboardSummarize(this.dashboardSummary, this.isSummarize)
            .then(function (data) {
            _this.dashboardActions.getDashboardHoldingSummary({
                data: data.holdingDashboardSummary,
                summary: data.holdingSummary,
                isOmneOnly: data === null || data === void 0 ? void 0 : data.isOmneOnly,
            }, ERports.HOLDINGS);
        });
    };
    HoldingReportPresenter.prototype.getSearchHoldingReportData = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var combinedState, searchedHoldingReportData, emptyValidation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (input.includes("\\"))
                            input = input.replace(/\\/g, "");
                        input = escapeRegexStr(input);
                        this.searchState = input;
                        // this.filterState = this.holdingReportData.FilterData; // set it to initial state
                        this.searchState.length > 0
                            ? this.GTMService.gtmService(new ReportGAEvents("".concat(ReportsGTMConstants.Search), "".concat(ReportsGTMConstants.NewReports, " | ").concat(ReportsGTMConstants.Holding), "".concat(input)))
                            : null;
                        combinedState = new HoldingUiState(this.searchState, this.filterState, this.sortState, this.isSummarize);
                        this.actions.hideEmptyValidation();
                        return [4 /*yield*/, this.commonUsecase.getModifiedData(this.holdingReportData, combinedState)];
                    case 1:
                        searchedHoldingReportData = _a.sent();
                        if (searchedHoldingReportData &&
                            searchedHoldingReportData.HoldingDetails.length > 0) {
                            this.actions.getHoldingReportData(searchedHoldingReportData);
                        }
                        else {
                            emptyValidation = EmptyValidation[EmptyIcon.SEARCH];
                            this.actions.getHoldingReportData(searchedHoldingReportData);
                            this.actions.setEmptyValidation({ emptyValidation: emptyValidation });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HoldingReportPresenter.prototype.clearSingleFilter = function (title) {
        var _a;
        (_a = this.filterState[title]) === null || _a === void 0 ? void 0 : _a.filters.forEach(function (filter) {
            if (filter.selected)
                filter.selected = false;
            return filter;
        });
        this.getFilteredHoldingReportData(this.filterState);
    };
    // For removing filters
    HoldingReportPresenter.prototype.removeFilters = function (title) {
        var _a, _b, _c, _d, _e, _f;
        var defaultFilter = (_b = (_a = this.filterState) === null || _a === void 0 ? void 0 : _a.simpleFilter) === null || _b === void 0 ? void 0 : _b.filters.map(function (filter) {
            if (filter.title === title) {
                filter.selected = false;
            }
            return filter;
        });
        var defaultAssetFilter = (_d = (_c = this.filterState) === null || _c === void 0 ? void 0 : _c.assetFilter) === null || _d === void 0 ? void 0 : _d.filters.map(function (filter) {
            if (filter.title === title) {
                filter.selected = false;
            }
            return filter;
        });
        var defaultProductAssetFilter = (_f = (_e = this.filterState) === null || _e === void 0 ? void 0 : _e.productAssetFilter) === null || _f === void 0 ? void 0 : _f.filters.map(function (filter) {
            if (filter.title === title) {
                filter.selected = false;
            }
            return filter;
        });
        this.getFilteredHoldingReportData({
            simpleFilter: { name: "Script Filter", filters: defaultFilter },
            assetFilter: { name: "Asset filter", filters: defaultAssetFilter },
            productAssetFilter: {
                name: "Product Asset Filter",
                filters: defaultProductAssetFilter,
            },
        });
    };
    // For clearing all filters
    HoldingReportPresenter.prototype.clearAllFilters = function () {
        var defaultFilter = this.filterState.simpleFilter.filters.map(function (filter) {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        var defaultAssetFilter = this.filterState.assetFilter.filters.map(function (filter) {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        var defaultProductAssetFilter = this.filterState.productAssetFilter.filters.map(function (filter) {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        this.getFilteredHoldingReportData({
            simpleFilter: { name: "Script Filter", filters: defaultFilter },
            assetFilter: { name: "Asset filter", filters: defaultAssetFilter },
            productAssetFilter: {
                name: "Product Asset Filter",
                filters: defaultProductAssetFilter,
            },
        });
    };
    HoldingReportPresenter.prototype.getDashboardStreamData = function (subscribe) {
        var _this = this;
        try {
            var symb_2 = subscribe ? this.dashboardSymbols : [];
            var streamMapKey = [
                streamKeys[0],
                streamKeys[1],
                streamKeys[2],
                streamKeys[3],
            ];
            this.worker.onmessage = function (event) {
                var _a = event.data, reportData = _a.reportData, type = _a.type;
                if (type === ReportName.HDASHBOARD)
                    _this.dashboardSummary = reportData;
            };
            this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, function (mappedData) { return __awaiter(_this, void 0, void 0, function () {
                var updateStreamData_2, error_2;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            if (!symb_2.includes(mappedData.symbol)) return [3 /*break*/, 2];
                            this.worker.postMessage({
                                type: ReportName.HDASHBOARD,
                                streamData: mappedData,
                                reportData: this.dashboardSummary,
                            });
                            return [4 /*yield*/, this.commonUsecase.dashboardSummarize(this.dashboardSummary, this.isSummarize)];
                        case 1:
                            updateStreamData_2 = _a.sent();
                            throttle(function () {
                                return _this.dashboardActions.getDashboardHoldingSummary({
                                    data: updateStreamData_2 === null || updateStreamData_2 === void 0 ? void 0 : updateStreamData_2.holdingDashboardSummary,
                                    summary: updateStreamData_2 === null || updateStreamData_2 === void 0 ? void 0 : updateStreamData_2.holdingSummary,
                                    isOmneOnly: updateStreamData_2 === null || updateStreamData_2 === void 0 ? void 0 : updateStreamData_2.isOmneOnly,
                                }, ERports.HOLDINGS);
                            }, 1000)();
                            _a.label = 2;
                        case 2: return [3 /*break*/, 4];
                        case 3:
                            error_2 = _a.sent();
                            console.log(error_2);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); }, symb_2, streamMapKey);
        }
        catch (error) {
            console.log(error);
        }
    };
    HoldingReportPresenter.prototype.saveProdAssetDropDown = function (prodAssetFilter) {
        this.actions.saveProdAssetDropDown(prodAssetFilter);
    };
    HoldingReportPresenter.prototype.saveSMTF = function (smtf) {
        this.actions.saveSMTF(smtf);
    };
    HoldingReportPresenter.prototype.getDpPullEmail = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return _this.dpPullUseCase.execute({
                onSuccess: function (status) {
                    resolve(status);
                },
                onError: function (error) {
                    reject(false);
                },
            }, req);
        });
    };
    HoldingReportPresenter.prototype.getHoldingReportDataQty = function () {
        var _this = this;
        var abortControllerHoldingsQty = new AbortController();
        return new Promise(function (resolve, reject) {
            _this.useCases.execute({
                onSuccess: function (HoldingReportData) {
                    if (HoldingReportData)
                        resolve(HoldingReportData.HoldingDetails);
                },
                onError: function (error) {
                    reject({
                        error: error,
                        isOpen: true,
                    });
                },
            }, { abortSignal: abortControllerHoldingsQty.signal });
        });
    };
    return HoldingReportPresenter;
}());
export default HoldingReportPresenter;
